enum Language {
    zh_TW = "zh-TW",
    en_US = "en-US"
}

export default Language;